import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-497ff933"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-remake" }, "最多添加 10 个导航，拖动选中的导航可对其排序", -1))
const _hoisted_3 = { class: "image-group-list" }
const _hoisted_4 = { class: "image-right-box" }
const _hoisted_5 = {
  key: 0,
  class: "image-item-box"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "标题", -1))
const _hoisted_7 = { class: "image-item-box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "链接", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_upload_image_list = _resolveComponent("ui-upload-image-list")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ui_select_link = _resolveComponent("ui-select-link")!
  const _component_ui_close_btn = _resolveComponent("ui-close-btn")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_ui_layout2 = _resolveComponent("ui-layout2")!
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_ui_layout1 = _resolveComponent("ui-layout1")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_draggable, {
        modelValue: _ctx.modelValue.list,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValue.list) = $event)),
        filter: ".close-btn-box"
      }, {
        item: _withCtx(({ element, index }) => [
          (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "image-group-item-box"
          }, [
            (_ctx.showImage)
              ? (_openBlock(), _createBlock(_component_ui_upload_image_list, {
                  key: 0,
                  modelValue: element.cover,
                  "onUpdate:modelValue": ($event: any) => ((element.cover) = $event),
                  showClose: false,
                  tips: "更换图片"
                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              (_ctx.showText)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _hoisted_6,
                    _createTextVNode(),
                    _createVNode(_component_el_input, {
                      modelValue: element.title,
                      "onUpdate:modelValue": ($event: any) => ((element.title) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_ui_select_link, {
                  modelValue: element.link,
                  "onUpdate:modelValue": ($event: any) => ((element.link) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ])
            ]),
            _createVNode(_component_ui_close_btn, {
              onClick: _withModifiers(($event: any) => (_ctx.removeImage(index)), ["stop"])
            }, null, 8, ["onClick"])
          ]))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, { onClick: _ctx.addImage }, {
        default: _withCtx(() => [
          _createTextVNode("添加导航")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_el_divider),
    _createVNode(_component_ui_layout2, { title: "列表样式" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.modelValue.showStyle,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelValue.showStyle) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_button, { label: "image-text" }, {
              default: _withCtx(() => [
                _createTextVNode("图文")
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio_button, { label: "image" }, {
              default: _withCtx(() => [
                _createTextVNode("图片")
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio_button, { label: "text" }, {
              default: _withCtx(() => [
                _createTextVNode("文字")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_ui_layout1, {
      title: "图文间隔",
      class: "view-item-box"
    }, {
      content: _withCtx(() => [
        _createVNode(_component_el_slider, {
          style: {"margin-left":"10px"},
          modelValue: _ctx.modelValue.imgGap,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelValue.imgGap) = $event)),
          "show-input": "",
          class: "slider-style-box",
          min: 0,
          max: 50,
          "show-input-controls": false
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_ui_layout1, {
      title: "左右间隔",
      class: "view-item-box"
    }, {
      content: _withCtx(() => [
        _createVNode(_component_el_slider, {
          style: {"margin-left":"10px"},
          modelValue: _ctx.modelValue.gap,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelValue.gap) = $event)),
          "show-input": "",
          class: "slider-style-box",
          min: 0,
          max: 50,
          "show-input-controls": false
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_ui_layout2, {
      title: "图片样式",
      class: "view-item-box"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.modelValue.mode,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelValue.mode) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_button, { label: "fixed" }, {
              default: _withCtx(() => [
                _createTextVNode("固定")
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio_button, { label: "scroll" }, {
              default: _withCtx(() => [
                _createTextVNode("横向滑动")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    (_ctx.modelValue.mode == 'scroll')
      ? (_openBlock(), _createBlock(_component_ui_layout2, {
          key: 0,
          title: "一屏显示",
          class: "view-item-box"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.modelValue.count,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modelValue.count) = $event)),
              placeholder: "请选择第二优先级",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (item, i) => {
                  return _createVNode(_component_el_option, {
                    key: i,
                    label: i + 2 + '个导航',
                    value: i + 2
                  }, null, 8, ["label", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_ui_layout2, {
      title: "字体颜色",
      ext: _ctx.modelValue.style.color
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "text",
          style: {"margin":"0 10px 0 0"},
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.modelValue.style.color = _ctx.defaultData.data.style.color))
        }, {
          default: _withCtx(() => [
            _createTextVNode("重置")
          ]),
          _: 1
        }),
        _createVNode(_component_el_color_picker, {
          modelValue: _ctx.modelValue.style.color,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modelValue.style.color) = $event)),
          onActiveChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.modelValue.style.color = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["ext"]),
    _createVNode(_component_ui_layout2, {
      title: "背景颜色",
      ext: _ctx.modelValue.style.backgroundColor
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "text",
          style: {"margin":"0 10px 0 0"},
          onClick: _cache[9] || (_cache[9] = ($event: any) => (
        _ctx.modelValue.style.backgroundColor = _ctx.defaultData.data.style.backgroundColor
        ))
        }, {
          default: _withCtx(() => [
            _createTextVNode("重置")
          ]),
          _: 1
        }),
        _createVNode(_component_el_color_picker, {
          modelValue: _ctx.modelValue.style.backgroundColor,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modelValue.style.backgroundColor) = $event)),
          onActiveChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.modelValue.style.backgroundColor = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["ext"])
  ]))
}